export const RELEASES_PACKAGE_NAME = 'jiraReleasesVersions' as const;
export const VERSIONS_ERROR_ANALYTICS = 'directories.versions.error';
